(function() {
    'use strict';

    angular.module('app.eventos', []);
})();
